import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=627f0048&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('627f0048')) {
      api.createRecord('627f0048', component.options)
    } else {
      api.reload('627f0048', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=627f0048&", function () {
      api.rerender('627f0048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/user/Register.vue"
export default component.exports